import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import { selectViewInContext } from '../../../shared/reducers';
import { Constants, transactionDetailLabels } from '../../../shared/utilities/Constants';
import { StandingAuthReviewPageActions } from '../../actions';
import { InternalTransferInfoSA } from '../../models/InternalTransferInfoSA';
import { ItStandingAuthDetails, isItStandingAuthDetails } from '../../models/standingAuthorizationForm';
import { selectStandingAuthInternalTransferInfo, selectStagedStandingAuthForm } from '../../reducers';
import { selectNraIndicator, selectStateCode } from '../../../account-info-header/reducers';

@Component({
  standalone: false,
  selector: 'mm-sa-transaction-details-section-it',
  templateUrl: './sa-transaction-details-section-it.component.html',
  styleUrls: ['./sa-transaction-details-section-it.component.scss']
})
export class SaTransactionDetailsSectionItComponent implements OnInit, OnDestroy {
  @Input() isInrFromTable: boolean;
  createRequestStep$: Observable<string>;
  readonly labels = transactionDetailLabels;
  readonly taxCopyParagraphOne: string = Constants.taxCopyParagraphOne;
  destroy$ = new Subject<void>();
  transactionType: string;
  info: InternalTransferInfoSA;
  displayRegistration: boolean = false;
  standingAuthDetails: ItStandingAuthDetails;
  saStateTaxLabel: string = transactionDetailLabels.stateTax;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.createRequestStep$ = this.store.select(selectViewInContext);

    this.store.select(selectStagedStandingAuthForm).pipe(takeUntil(this.destroy$)).subscribe(form => {
      if (form.transactionType){
        this.transactionType = 'Internal cash transfers (journal)';
        if (form.isSubmitAndCreateBundledSa){
          this.transactionType += ' - bundled';
        }
      }

      if (isItStandingAuthDetails(form.standingAuthorizationDetails)){
        this.standingAuthDetails = form.standingAuthorizationDetails;
      }
    });
    this.store.select(selectStandingAuthInternalTransferInfo).pipe(takeUntil(this.destroy$)).subscribe(itInfo => {
      this.info = itInfo;
      this.displayRegistration = itInfo.toAccountInfo.accountRegistration.length > 0;
    });

    combineLatest([
      this.store.select(selectStateCode),
      this.store.select(selectNraIndicator)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([stateCode, nraIndicator]) => {
      if (stateCode && !nraIndicator) {
        this.saStateTaxLabel = `${transactionDetailLabels.stateTax} (${stateCode})`;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onEditClicked() {
    this.store.dispatch(StandingAuthReviewPageActions.editClicked());
  }

  get displayNickname(): boolean {
    return !!this.standingAuthDetails?.authorizationNickname;
  }
}
